import { FetchAPI } from "./Main/fetchAPI";
import { CLINICAL_SUPERVISORS, USER, USERS } from "./constants";
import {
    AssignBCBAsProperties,
    AssignClinicalSupervisorProperties,
    SaveUserDataProperties,
    UpdateUserDataProperties,
    UserPaginationProperties,
    section,
} from "./userAPIProperties";

export const UserAPI = {
    authorization: {
        getAuthorizationTypes: () => FetchAPI.getJson({
            urlStr: `${USER}/authorization-types`,
        }),
    },
    clinicalSupervisor: {
        getClinicalSupervisorsTherapists: (userId: string) => FetchAPI.getJson({
            urlStr: `${CLINICAL_SUPERVISORS}/${userId}/therapists`,
        }),
        getClinicalSupervisorsBCBAs: (userId: string) => FetchAPI.getJson({
            urlStr: `${CLINICAL_SUPERVISORS}/${userId}/bcbas`,
        }),
        getBCBAClinicalSupervisors: (userId: string) => FetchAPI.getJson({
            urlStr: `${USERS}/bcbas/${userId}/clinical-supervisors`,
        }),
        assignClinicalSupervisors: (data: AssignClinicalSupervisorProperties) => FetchAPI.postJson({
            urlStr: `${USERS}/bcbas/${data.userId}/clinical-supervisors`,
            data,
        }),
        assignBCBAs: (data: AssignBCBAsProperties) => FetchAPI.postJson({
            urlStr: `${USERS}/clinical-supervisors/${data.clinicalSupervisorId}/bcbas`,
            data,
        }),
    },
    user: {
        getClinicalSupervisorsTherapists: (userId: string) => FetchAPI.getJson({
            urlStr: `${USERS}/clinical-supervisors/${userId}/therapists`,
        }),
        getUsers: (data: UserPaginationProperties) => {
            const {
                page,
                pageSize,
                direction,
                orderBy,
                role,
                searchString,
                section,
            } = data;
            const query = new URLSearchParams();

            if (!!searchString) query.set('searchString', searchString);
            if (!!direction) query.set('direction', direction);
            if (!!orderBy) query.set('orderBy', orderBy);
            if (!!role) query.set('role', role);
            if (!!section) {
                return FetchAPI.getJson({ urlStr: `${USERS}/${section}/${pageSize}/${page}?${query.toString()}` });
            };

            return FetchAPI.getJson({ urlStr: `${USERS}/${pageSize}/${page}?${query.toString()}` });
        },
        getUsersBySection: (data: UserPaginationProperties, section: section) => {
            const {
                page,
                pageSize,
                direction,
                orderBy,
                role,
                searchString,
                caseCoordinatorId,
            } = data;
            const query = new URLSearchParams();

            if (!!searchString) query.set('searchString', searchString);
            if (!!direction) query.set('direction', direction);
            if (!!orderBy) query.set('orderBy', orderBy);
            if (!!role) query.set('role', role);
            if (typeof caseCoordinatorId === 'string') query.set('caseCoordinatorId', caseCoordinatorId);

            return FetchAPI.getJson({ urlStr: `${USERS}/${section}/${pageSize}/${page}?${query.toString()}` });
        },
        addUser: (data: SaveUserDataProperties) => FetchAPI.postJson({
            urlStr: `${USERS}`,
            data,
        }),
        getUser: (id: string) => FetchAPI.getJson({
            urlStr: `${USERS}/${id}`,
        }),
        updateUser: ({ id, data }: UpdateUserDataProperties) => FetchAPI.putJson({
            urlStr: `${USERS}/${id}`,
            data
        }),
        deleteUser: (id: string) => FetchAPI.deleteJson({
            urlStr: `${USERS}/${id}`,
        }),
    },
    insurance: {
        getUserInsurances: (id: string) => FetchAPI.getJson({
            urlStr: `${USERS}/${id}/insurances`,
        }),
    }
}